import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Star, Shield, FileText, ArrowRight, Facebook, Instagram, Linkedin } from 'lucide-react';
import { COMPANY_INFO, PRODUCTS, PRODUCT_CATEGORIES } from '../data';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-top-inner">
          <div className="footer-cta-text">
            <span className="footer-cta-eyebrow">Ready to get protected?</span>
            <h3>Get Your Free Consultation Today</h3>
          </div>
          <div className="footer-cta-actions">
            <Link to="/get-quote" className="btn-primary">
              <Shield size={15} /> Get a Quote
            </Link>
            <a href={`tel:${COMPANY_INFO.phone}`} className="btn-outline-white">
              <Phone size={15} /> {COMPANY_INFO.phone}
            </a>
          </div>
        </div>
      </div>

      <div className="footer-main">
        <div className="container footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo-wrap">
              <img src={COMPANY_INFO.logo} alt="Prime Sentinel" className="footer-logo-img"
                onError={e => { e.target.style.display='none'; }} />
              <div>
                <div className="footer-logo-name">Prime Sentinel</div>
                <div className="footer-logo-sub">Insurance Solutions</div>
              </div>
            </Link>
            <p className="footer-brand-desc">
              Licensed commercial insurance agency specializing in transportation,
              business, and personal insurance coverage throughout California and nationwide.
            </p>
            <div className="footer-rating">
              <div className="footer-stars">
                {[1,2,3,4,5].map(i => <Star key={i} size={14} fill="#c9a84c" color="#c9a84c" />)}
              </div>
              <span>5.0 · 40+ Google Reviews</span>
            </div>
            <div className="footer-social">
              <a href={COMPANY_INFO.socials.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="footer-social-link">
                <Facebook size={18} />
              </a>
              <a href={COMPANY_INFO.socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="footer-social-link">
                <Instagram size={18} />
              </a>
              <a href={COMPANY_INFO.socials.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="footer-social-link">
                <Linkedin size={18} />
              </a>
              <a href={COMPANY_INFO.googleReviewsUrl} target="_blank" rel="noopener noreferrer" aria-label="Google Reviews" className="footer-social-link">
                <Star size={18} />
              </a>
            </div>
          </div>

          {/* Product columns by category */}
          {PRODUCT_CATEGORIES.map(cat => (
            <div key={cat.id} className="footer-col">
              <h4 className="footer-col-title">{cat.label}</h4>
              <ul className="footer-links">
                {PRODUCTS.filter(p => p.category === cat.id).map(p => (
                  <li key={p.slug}>
                    <Link to={`/products/${p.slug}`}>
                      <ArrowRight size={12} /> {p.shortTitle}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Company */}
          <div className="footer-col">
            <h4 className="footer-col-title">Company</h4>
            <ul className="footer-links">
              {[
                ['About Us', '/about'],
                ['Our Team', '/about#team'],
                ['Careers', '/careers'],
                ['Financing', '/financing'],
                ['Contact', '/contact'],
                ['Download Your COI', '/certificate'],
                ['Get a Quote', '/get-quote'],
                ['Privacy Policy', '/privacy-policy'],
              ].map(([label, path]) => (
                <li key={path}>
                  <Link to={path}><ArrowRight size={12} /> {label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4 className="footer-col-title">Contact Us</h4>
            <div className="footer-contact-list">
              <a href={`tel:${COMPANY_INFO.phone}`} className="footer-contact-item">
                <Phone size={15} /> {COMPANY_INFO.phone}
              </a>
              <a href={`tel:${COMPANY_INFO.fax}`} className="footer-contact-item">
                <Phone size={15} /> Fax: {COMPANY_INFO.fax}
              </a>
              <a href={`mailto:${COMPANY_INFO.email}`} className="footer-contact-item">
                <Mail size={15} /> {COMPANY_INFO.email}
              </a>
              <div className="footer-contact-item">
                <MapPin size={15} style={{ flexShrink: 0, marginTop: '2px' }} />
                <span>{COMPANY_INFO.address}<br />{COMPANY_INFO.city}</span>
              </div>
            </div>
            <Link to="/certificate" className="footer-cert-link">
              <FileText size={15} /> Download Your COI
            </Link>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>© {year} {COMPANY_INFO.name}. All rights reserved. · <Link to="/privacy-policy" style={{ color: 'inherit', textDecoration: 'underline' }}>Privacy Policy</Link></span>
          <span>
            Licensed Insurance Agency · California DOI {COMPANY_INFO.license}
          </span>
        </div>
      </div>
    </footer>
  );
}